import React, { useState } from "react";

import PredeterminadosPaciente from "./PredeterminadosPaciente";

import "../css/Settings.css";
import "../css/PatientsSettingsScreen.css";

export default function PatientsSettingsScreen(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="patient-container">
      <div className="optometry-icon-header">
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 0 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(0);
          }}
        >
          <img
            src={
              selectedTab === 0
                ? "/images/optometry-orange.svg"
                : "/images/optometry-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Predeterminados de pacientes</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 1 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(1);
          }}
        >
          <img
            src={
              selectedTab === 1
                ? "images/anamnesis-orange.svg"
                : "/images/anamnesis-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Fechas de revisión</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 2 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(2);
          }}
        >
          <img
            src={
              selectedTab === 2
                ? "/images/rx-orange.svg"
                : "/images/rx-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Oftalmólogos</span>
        </button>
      </div>
      <div className="cfg-body-container">
        {selectedTab === 0 && (
          <PredeterminadosPaciente {...props} show={selectedTab === 0} />
        )}
      </div>
    </div>
  );
}
